export default __webpack_public_path__ + "static/media/Cloudxier-whychooseus-02.4e86266a.png";